export function setupInspirationFilter() {
    const inspirationFilter = event => {
        const element = event.target;
        const filterType = element.getAttribute('data-filter');
        const filterValue = [];
        let listFiltered = false;

        // Get values of the checked filters and check if list has been filtered by a different filter type
        inspirationFilters.forEach(filter => {
            if (filter.getAttribute('data-filter') === filterType && filter.checked) {
                filterValue.push(filter.value);
            }
            if (filter.getAttribute('data-filter') !== filterType && filter.checked) {
                listFiltered = true;
            }
        });

        // Only show matching items
        inspirationItems.forEach(item => {
            let itemInclude = false;

            //if (filterValue.length === 0 || filterValue.some(value => value.indexOf(item.getAttribute(`data-${filterType}`)) > -1)) {
            if (filterValue.length === 0) {
                itemInclude = true;
            } else {
                filterValue.forEach(value => {
                    if (item.getAttribute(`data-${filterType}`).indexOf(value) != -1) {
                        itemInclude = true;
                    }
                });
            }

            if (itemInclude) {
                item.classList.remove(`js-hidden-${filterType}`);
            } else {
                item.classList.add(`js-hidden-${filterType}`);
            }
        });

        // Only check for available filters if list haven't been filtered by different filter type
        if (!listFiltered) {
            if (filterValue.length === 0) {
                inspirationFilterAvailability('reset');
            } else {
                inspirationFilterAvailability(filterType);
            }
        }

        if (inspirationList) {
            if (filterValue.length !== 0) {
                inspirationList.classList.add('js-filtered');
            } else {
                inspirationList.classList.remove('js-filtered');
            }
        }
    };

    const inspirationFilterAvailability = filterType => {
        if (filterType === 'reset') {
            inspirationFilters.forEach(filter => {
                filter.disabled = false;
            });
        } else {
            const filterValue = [];

            inspirationItems.forEach(item => {
                if (!item.classList.contains(`js-hidden-${filterType}`)) {
                    filterValue.push(item.getAttribute('data-project-type'));
                    filterValue.push(item.getAttribute('data-wood-type'));
                }
            });
            inspirationFilters.forEach(filter => {
                if (filter.getAttribute('data-filter') !== filterType) {
                    if (!filter.checked && filterValue.some(value => value.indexOf(filter.value) > -1)) {
                        filter.disabled = false;
                    } else {
                        filter.disabled = true;
                    }
                }
            });
        }
    };

    const inspirationList = document.querySelector('.inspiration-overview .overview__list');
    const inspirationItems = document.querySelectorAll('.inspiration-overview .overview__item');
    const inspirationFilters = document.querySelectorAll('[data-action="inspiration-filter"]');

    inspirationFilters.forEach(filter => {
        filter.addEventListener('change', inspirationFilter);
    });
}